import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="vertrag-kosten"
export default class extends Controller {
	static targets = ["einfach", "detail"]

	connect() {}

	toggle() {
		this.einfachTargets.forEach((e) => e.classList.toggle("hidden"))
		this.detailTargets.forEach((e) => e.classList.toggle("hidden"))
	}
}
